export default "__VITE_ASSET__CmN9lRYb__"